/**
 * Asynchronously loads the component for StudentUpskilling
 */

import { lazyLoad } from 'utils/loadable';

export const StudentUpskilling = lazyLoad(
  () => import('./index'),
  module => module.StudentUpskilling,
);